export default "https://cdn-static-staging.gokick.com/assets/8a9bc5ae92c259feb7c9591453bfa6ace937db28/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";